import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { connect } from 'dva';
import { router } from 'umi';
import { Toast } from 'antd-mobile';
import { parseDate, daysDistance, getReleaseDate } from '@/utils/time';
import NavBar from '@/components/NavBar';
import Icon from '@/components/Icon';
import TimeTab from '@/components/TimeTab';
import FilterMenuBar from '@/components/FilterMenuBar';
import CinemaItem from '@/components/CinemaItem';
import PullLoad from '@/components/PullLoad';
import Notice from '@/components/Notice';
import api from '@/common/api';
import { getMovieDeatil } from '@/entity/module/movieDetail/indexAPi';
import MovieDeatilProps from '@/entity/module/movieDetail/index';
import { ActiveMenuType, IMovieCinemeData, ITimeTabItem } from '@/interface/index';
import { detailQuery } from '@/interface/req';
import { initCinamaMovieData } from '@/interface/init';
import { getOrderDesc } from '@/utils/other';
import styles from './index.less';
import placeholderImg from '@/assets/imgs/placeholderimg.png';
import { BFD_checkApp } from '@/utils/bfdApp';
import { checkXcx } from '@/utils/checkXcx';
import MovieInfo from './components/movieInfo';
import { errorLog, getSessonStorage, setSessonStorage, unionFlag } from '@/utils';
import nodataIcon from '../../assets/imgs/nodata@2x.png';
import SuspendServe from '@/components/SuspendServe';
import { TLang } from '@/utils/lang';
import homeReq from '@/entity/module/home/homeAPi';
import DFWebUtilsTools from '@df-fe/df-web-utils-tools';
import { getLocation } from '@/utils/index';
import { MovieSkeleton, MovieTabSkeletonBottom, MovieTabSkeletonTop } from '@/components/skeleton';

// interface IDistrictObj{
//   id: number
//   cinemaCount: number,
//   name: string,
//   districtId?:number
// }
const sortArr = [
  {
    value: 1,
    label: TLang('综合排序', 'home', false, false, null)
  },
  {
    value: 2,
    label: TLang('离我最近', 'home', false, false, null)
  },
  {
    value: 3,
    label: TLang('价格最低', 'home', false, false, null)
  }
];
const MovieDetail = (props: MovieDeatilProps) => {

  const [showInitSkeleton, setShowInitSkeleton] = useState(true);
  const [showTabSkeleton, setShowTabSkeleton] = useState(true);
  // 页码
  const [pageIndex, setPageIndex] = useState<number>(1);

  // 电影详情数据
  const [movie, setMovie] = useState<any>();
  // 控制 电影详情 的按钮状态
  const [showToggleBtn, setShowToggleBtn] = useState(false);
  // 电影详情 flag
  const [descFlag, setDescFlag] = useState(false);

  // 定义菜单 bar 那个处于活跃状态
  const [active, setActive] = useState<ActiveMenuType>(ActiveMenuType.none);
  // 区域、商圈 数据
  const [districtBusinessData, setDistrictBusinessData] = useState();
  // 左边、右边 菜单数据
  const [leftBarObj, setLeftBarObj] = useState<any>();
  const [rightBarObj, setRightBarObj] = useState<any>();
  //
  const [timeMenuTop, setTimeMenuTop] = useState(0);

  // 影院列表
  const [cinemaList, setCinemaList] = useState<IMovieCinemeData>(initCinamaMovieData);

  const [showDateItem, setShowDateItem] = useState<ITimeTabItem | null>(null);

  // 时间
  const [timeTabArr, setTimeTabArr] = useState<Array<ITimeTabItem>>([]);
  const [mid] = useState(props.history.location.query.id);
  const [showNotice, setShowNotice] = useState(false);
  // 获取电影详情 -> 解析时间 -> 获取商圈 -> 获取影院列表
  useEffect(() => {
    setTimeTabArr([]);
    loadDataParams();
    // 获取 id .请求数据
    // const id = props.history.location.query.id
    // request movie data
    getMovieDeatil(mid).finally(() => {
      setShowInitSkeleton(false);
    }).then((res) => {
      if (!res) {
        return;
      }
      setMovie(res);
      if (res.alert && res.alert.length > 0) {
        setShowNotice(true);
      }
      if (res && res.id) {
        loadShowDate(res);
      } else {
        errorLog('getMovieDeatil', '影片信息未正常加载', { error: { data: res } });
        console.error('影片信息未正常加载', res);
      }
  });
  }, [props.currentAddress]);


  const loadShowDate = (data) => {
    let arr: Array<ITimeTabItem> = [];
    console.log('showDates', data?.showDates);
    data?.showDates?.forEach((i) => {
      try {
        const d = daysDistance(i);
        if (d > -1) {
          const info: ITimeTabItem = parseDate(i);
          arr.push(info);
        }
      } catch (e) {
        errorLog('loadShowDate', '日期异常', { error: { data: data, error: e } });
        console.log('日期异常', e);
      }
    });

    if (arr.length <= 0) {
      return; //Toast.info('该影片暂无放映排期');
    }
    let dataParams = { ...props.dataParams };
    if (!dataParams || dataParams.movieId != mid) {
      arr[0].status = true;
      setShowDateItem(arr[0]);
      // console.log(arr);
    } else {
      const i: any = dataParams?.dateItem;
      if (i) {
        setShowDateItem(i);
        arr = arr.map((item) => {
          item.status = false;
          if (item.origin === i.origin && item.date === i.date) {
            item.status = true;
          }
          return item;
        });
      } else {
        arr[0].status = true;
        setShowDateItem(arr[0]);
      }
    }
    setTimeTabArr(arr);
  };

  useEffect(() => {
    const timeNavTopDom: any = document.querySelector('.timeMenu');
    const timeNavTop = timeNavTopDom?.offsetTop || 0;
    setTimeMenuTop(timeNavTop);
  }, [descFlag, movie]);

  // 点击了时间
  const timeHandle = (s: ITimeTabItem, idx: number) => {
    setActive(ActiveMenuType.none);
    setPageIndex(1);
    let dateItem: any = s;
    if (typeof idx === 'undefined') { // 1+
      const idx = timeTabArr?.findIndex((i) => i.origin === s?.origin);

      const nextIdx = idx;
      const newArr = timeTabArr?.map((ite, index) => {
        if (index === nextIdx) {
          ite.status = true;
        } else {
          ite.status = false;
        }
        return ite;
      });
      const i: any = newArr?.find((ite) => ite.status === true);
      setTimeTabArr(newArr);
      dateItem = i;
      setShowDateItem(i);
    } else { // 0
      setShowDateItem(s);
    }

    let dataParams = { ...props.dataParams };
    dataParams.dateItem = dateItem;
    setCacheParams(dataParams);

    // setShowDateItem(s);
    // // 需要 scroll to top
    scrollToTop();
    // // 获取 商圈、

  };

  useEffect(() => {
    if (showDateItem) {
      try {
        loaCinemaList();
      } catch (e) {
        errorLog('loaCinemaList', TLang('加载影院信息异常', 'home', false, false, null), { error: { error: e, data: showDateItem } });
        console.error('加载影院信息异常', e);
      }
    }
  }, [showDateItem]);

  const loaCinemaList = () => {
    if (showDateItem) {
      setShowTabSkeleton(true);
      queryDistrictCount().finally(() => {
        // setShowTabSkeleton(false);
      }).then((res) => {
        const q: detailQuery = {};
        q.movieId = mid;
        q.pageIndex = 1;
        q.showDate = showDateItem?.origin;
        q.businessDistrictId = res && res.left && res.left.value;
        q.districtId = res && res.left.districtId;
        q.orderDescs = getOrderDesc(res?.right?.value);

        let sloc = getSessonStorage('systemLoaction');
        if (!sloc) {
          getLocation()
          .then((val) => {
            console.log('定位结果1111', val);
            setSessonStorage('systemLoaction', JSON.stringify({ location:val.location }));
            queryCinemaList(q);
          })
          .catch((err) => {
            queryCinemaList(q);
          });
        } else {
          queryCinemaList(q);
        }
      });
    }
  };

  const scrollToTop = () => {
    const dom: any = document.querySelector('.navBarContainer');
    const barHei = dom.offsetHeight || 0;
    const containerDom: any = document.querySelector('.am-drawer-content');
    if (timeMenuTop > barHei) {
      containerDom?.scrollTo(0, timeMenuTop);
    }
  };
  function filterMenuBarClick(t: ActiveMenuType) {
    // scroll to top

    // chang active
    if (t === ActiveMenuType.left) {
      setActive(ActiveMenuType.left);
      scrollToTop();
    } else if (t === ActiveMenuType.right) {
      setActive(ActiveMenuType.right);
      scrollToTop();
    } else {
      setActive(ActiveMenuType.none);
    }

  }
  // 点击了bar菜单 item
  function filterMenuBarItemHandle(item: any) {
    // request
    setPageIndex(1);
    setActive(ActiveMenuType.none);
    // console.log('item',item,props)
    const q: detailQuery = {};
    q.movieId = mid;
    q.pageIndex = 1;
    q.showDate = showDateItem?.origin;
    let dataParams = { ...props.dataParams };
    if (item.type === 1) {

      setLeftBarObj(item.data);
      dataParams.left = item.data;
      dataParams.movieId = mid;
      setCacheParams(dataParams);
      q.businessDistrictId = item.data.value;
      q.districtId = item.data.districtId;
      q.orderDescs = getOrderDesc(rightBarObj?.value);
    } else if (item.type === 2) {
      setRightBarObj(item.data);
      dataParams.right = item.data;
      dataParams.movieId = mid;
      setCacheParams(dataParams);
      if (leftBarObj && leftBarObj?.districtId) {
        q.businessDistrictId = leftBarObj.value;
        q.districtId = leftBarObj.districtId;
      }
      q.orderDescs = getOrderDesc(item.data.value);

    }
    queryCinemaList(q);

  }
  // 如果是后退进入页面从缓存中读取参数
  const loadDataParams = () => {
    // 如果用户是从搜索进入清空用户操作缓存
    if (document.referrer.indexOf('/ms/home') > -1) {
      setCacheParams(null);
      return;
    }
    const params = props.dataParams;
    if (!params || params.movieId != mid) {
      setCacheParams(null);
      return;
    }
    // 右侧条件
    setRightBarObj(params.right);
    // 左侧条件
    setLeftBarObj(params.left);
  };

  // 记录操作
  const setCacheParams = (params: any) => {
    props.dispatch && props.dispatch({ type: 'movie/setUserDataParams', payload: params });
  };

  // 请求商圈数据
  const queryDistrictCount = () => api.getDistrictCounyByMovie(mid, showDateItem?.origin).then((res) => {
    setDistrictBusinessData(undefined);
    if (!res) return;
    const { businessDistrict, district } = res;
    // 转换的菜单数据
    const menuData = district && district.map((districtItem) => {
      const oriBusData = businessDistrict.filter((busItem) => busItem.districtId === districtItem.id);
      const busData = oriBusData.map((busI) => ({
        label: busI.name,
        value: busI.id,
        cinemaCount: busI.cinemaCount,
        districtId: busI.districtId
      }));
      return { label: districtItem.name, value: districtItem.id, cinemaCount: districtItem.cinemaCount, children: busData };
    });
    setDistrictBusinessData(menuData);
    let dataParams: any = {};
    if (!leftBarObj) {
      dataParams.left = menuData && menuData[0];
      setLeftBarObj(menuData && menuData[0]);
    } else {
      dataParams.left = leftBarObj;
    }
    const orderBy = props.history.location.query.orderBy;
    const orderType = !orderBy ? sortArr[0] : sortArr[orderBy];
    if (!rightBarObj) {
      dataParams.right = orderType;
      setRightBarObj(orderType);
      const params = props.history.location.search.replace('&orderBy=1', '').replace('?', '');
      let url = props.history.location.pathname + '?' + params;
      props.history.replace(url);
    } else {
      dataParams.right = rightBarObj;
    }
    if (dataParams.left || dataParams.right) {
      dataParams = !props.dataParams ? Object.assign({ ...props.dataParams }, dataParams) : props.dataParams;
      dataParams.movieId = mid;
      setCacheParams(dataParams);
    }
    // setLeftBarObj(menuData[0]);
    // setRightBarObj(sortArr[0]);

    return { left: leftBarObj || menuData && menuData[0], right: rightBarObj || (orderType || sortArr[0]) };
  });
  const queryCinemaList = (params?: detailQuery | any, left?: any) => {

    const q: detailQuery = {};
    q.movieId = mid;
    q.pageIndex = 1;
    q.pageSize = 20;
    q.showDate = showDateItem?.origin;
    q.orderDescs = getOrderDesc(rightBarObj ? rightBarObj.value : 1);// right bar default value 1
    if (left) {
      q.businessDistrictId = '';
      q.districtId = left?.value;
    } else if (leftBarObj && leftBarObj.districtId) {
      q.businessDistrictId = leftBarObj?.value;
      q.districtId = leftBarObj?.districtId;
    } else if (leftBarObj) {
      q.businessDistrictId = '';
      q.districtId = leftBarObj?.value;
    }
    let _dataParams = params ? params : q;
    return api.getCinemaListByMovie(_dataParams).then((res) => {
      setShowTabSkeleton(false);
      if (!res) {
        return;
      }
      // 记录用户筛选条件
      // console.log(cinemaList,'cinemaList')
      // const obj = {hasNext:true,totalCount:res.totalCount,searches:[...(cinemaList?cinemaList.searches:[]) ,...res.searches]}
      setCinemaList(res);
      return res;
    });
  };


  const queryMoreCinemaList = (idx) => {
    const q: detailQuery = {};
    if (leftBarObj) {
      q.businessDistrictId = leftBarObj?.value;
      q.districtId = leftBarObj?.districtId;
    }
    if (rightBarObj) {
      q.orderDescs = getOrderDesc(rightBarObj.value);
    }
    q.movieId = mid;
    q.pageIndex = idx;
    q.pageSize = 20;
    q.showDate = showDateItem?.origin;
    return api.getCinemaListByMovie(q).then((res) => {

      setCinemaList((last) => ({ hasNext: res.hasNext, totalCount: res.totalCount, searches: [...(last ? last.searches : []), ...res.searches] }));
      setPageIndex(idx);
      return res;
    });
  };

  const closeMenuBar = () => {
    setActive(ActiveMenuType.none);
  };

  const loadMoreData = () => {
    // console.log('more',pageIndex);
    queryMoreCinemaList(pageIndex + 1);
  };
  const changeToNextDate = () => {
    const idx: number = timeTabArr?.findIndex((i) => i.origin === showDateItem?.origin) || 0;

    const nextIdx = idx + 1;
    if (nextIdx === timeTabArr?.length) {
      return;
    }
    const newArr = timeTabArr?.map((ite, index) => {
      if (index === nextIdx) {
        ite.status = true;
      } else {
        ite.status = false;
      }
      return ite;
    });
    const i: any = newArr?.find((ite) => ite.status === true);
    if (i) {
      setTimeTabArr(newArr);
      setShowDateItem(i);
      queryCinemaList();
    }
  };

  const gotoCiname = useCallback((item) => {
    props.dispatch && props.dispatch({ type: 'cinema/setMId', payload: mid });
    props.dispatch && props.dispatch({ type: 'cinema/setCimemaId', payload: item.id });
    const params: any = {
      mid: mid,
      cid: item.id
    };
    if (showDateItem?.origin) {
      params.date = showDateItem.origin;
    }
    router.push({
      pathname: '/cinema',
      query: {
        ...params
      }
    });
  }, [showDateItem]);

  const actors = useMemo(() => {
    // console.log(movie);
    if (movie?.actor) {
      let as = movie.actor.split('/');
      return as;
    }
    return [];
  }, [movie]);
  const directors = useMemo(() => {
    if (movie?.director) {
      let ds = movie.director.split('/');
      return ds;
    }
    return [];
  }, [movie]);
  const isApp = BFD_checkApp();
  // const isXcx = checkXcx();
  const union = unionFlag() || getSessonStorage('dffl_union');
  // TODO: 根据浙商union判断是否展示，浙商小程序添加汉堡包按钮
  const isXcx = checkXcx() && union !== 'ejyshop';
  const detailBy = props.history.location.query.detailBy;

  if (showInitSkeleton) {
    return (
      <>
        <MovieSkeleton></MovieSkeleton>
        {
          // @ts-ignore
          (isApp === false && !isXcx) ? <NavBar initColor="#FFF" targetColor="#333" targetBgColor="#FFF" opacity={0} /> : null
        }
      </>
    );
  }
  return <div className={`${styles.mDetailContainer} movieDetail`}>
    {
      movie ? <>
        {
          (isApp === false && !isXcx) ? <NavBar initColor="#FFF" targetColor="#333" targetBgColor="#FFF" opacity={0} /> : null
        }
        <MovieInfo movie={movie} defaultShowAll={movie?.showDates == null}></MovieInfo>
        {movie?.showDates != null ? <>
          <div className={`${styles.timeMenuWrapper} timeMenu ${isApp || isXcx ? styles.appStyle : null}`} >
            {timeTabArr ? <TimeTab data={timeTabArr} onClick={timeHandle} /> : null}
            {showTabSkeleton && <MovieTabSkeletonTop></MovieTabSkeletonTop>}
            {!showTabSkeleton && !!districtBusinessData?.length &&
              (<div className={styles.navMenuBar}>
                <FilterMenuBar maskHei="100vh" data={districtBusinessData} leftObj={leftBarObj} rightObj={rightBarObj} closeMenuBar={() => { closeMenuBar(); }} active={active} changeActive={filterMenuBarClick} clickItem={filterMenuBarItemHandle} />
              </div>)
            }
          </div>
          {showTabSkeleton && <MovieTabSkeletonBottom></MovieTabSkeletonBottom>}
          {!showTabSkeleton && (
            <>
              <div className={styles.listContainer}>
                {
                  cinemaList?.searches?.map((item, idx) => <CinemaItem {...item} key={idx} noBorder={idx === cinemaList.searches.length - 1} onClick={gotoCiname} showTime />)
                }
              </div>
              {
                (timeTabArr && timeTabArr.length > 0 && cinemaList.hasNext === false && cinemaList.searches.length === 0) ? <div className={styles.noCiname}>
                  <span>{`${showDateItem?.label}${showDateItem?.date}${TLang('暂无影院排期', 'home', false, false, null)}`}</span>
                  <div onClick={changeToNextDate}>{TLang('看看其他日期', 'home', false, false, null)}</div>
                </div> : null
              }
            </>
          )}
        </> : (detailBy && detailBy == 1 || getReleaseDate(movie.releaseDate)) ? null : <SuspendServe
          msg={TLang('暂无影院排期', 'home', false, false, null)}
          img={nodataIcon}
          mHieght={null}
                                                                                        />
        }
        <PullLoad clientDom=".am-drawer-content" docuDom=".movieDetail" hasMore={cinemaList ? cinemaList.hasNext : true} show={cinemaList && cinemaList.searches.length !== 0} loadMore={loadMoreData} />
      </> : null
    }

  </div >;
};
export default connect((state) => ({ ...state.movie, ...state.initData }))(MovieDetail);
// export default MovieDetail

